import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks/redux-hooks';
import {
  setShowSidebar,
  setThreadId,
  setToastInfo,
} from '../store/common.slice';
import Tooltip from './common/Tooltip';
import AgentService from '../services/agent.service';
import useStorage from '../hooks/useStorage';
import { ToastType } from '../types/common.types';
import { setChatData } from '../store/chat.slice';

const Header = () => {
  const { showSidebar, userInfo, agentInfo } = useAppSelector(
    (state) => state.common
  );
  const { chatData } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  const { setItem, getItem } = useStorage();

  const showToast = useCallback(
    (message: string, type: ToastType) => {
      dispatch(setToastInfo({ isOpen: true, message, type }));
    },
    [dispatch]
  );

  const initThread = useCallback(async (forceNew: boolean = false): Promise<boolean> => {
    if (!forceNew && chatData && chatData.length > 0) {
      return true;
    }

    try {
      const response = await AgentService.createThread();
      if (response.data.data) {
        dispatch(setThreadId(response.data.data));
        setItem('threadId', response.data.data);
        setItem('chatData', '[]');
        dispatch(setChatData([]));
        return true;
      } else {
        console.warn('Thread creation failed: no data');
        showToast(
          'Error in creating new thread. Please refresh the page.',
          ToastType.ERROR
        );
        return false;
      }
    } catch (err) {
      console.error('Thread creation error:', err);
      showToast(
        'Error in creating new thread. Please refresh the page.',
        ToastType.ERROR
      );
      return false;
    }
  }, [dispatch, getItem, setItem, showToast]);

  return (
    <header
      className="flex items-center justify-between px-5 py-1 h-[45px] fixed top-0 left-0 w-full z-20"
      style={{ background: 'transparent' }}
    >
      <div className="flex items-center gap-3">
        {userInfo && (
          <i
            className="icon-sidebar-close text-2xl cursor-pointer"
            onClick={() => dispatch(setShowSidebar(!showSidebar))}
          />
        )}
        <Tooltip content="New Chat" direction="bottom">
          <i
            className="icon-edit text-2xl cursor-pointer"
            onClick={() => initThread(true)}
          />
        </Tooltip>
      </div>
      {/* <div className="flex-1 flex justify-center items-center">
        {agentInfo?.createdByOrg?.companyLogo && (
          <img
            src={agentInfo.createdByOrg.companyLogo}
            alt={
              agentInfo.createdByOrg?.organisationName || 'Organization Logo'
            }
            className="inline-block max-w-[200px] max-h-[42px] object-contain"
          />
        )}
      </div> */}
    </header>
  );
};

export default Header;
